import { AuthApiPayload, Params } from '../types';
import {
  AuthStep,
  AuthStepItemType,
  AuthStepLabelledItem,
  UrlPart,
  UrlPartType,
} from '../../stepRenderer';

// TODO: look later/refactor https://github.com/HubSpotEngineering/si-datasync-fe/issues/122

export function buildApiPayload(
  sessionId: string,
  steps: Array<AuthStep>,
  params: Params,
  oAuthParams?: Map<string, string> | URLSearchParams,
  oAuthState?: string,
  oAuthScopeSet?: string[],
  mcpParams?: { clientId: string; serverUrl: string } | null,
  appId?: number
) {
  const payload: AuthApiPayload = {
    sessionId,
    authParams: {},
    inputParams: {},
    upstreamParams: {},
    oAuthParams: undefined,
    ...(appId !== undefined && { appId }),
  };

  steps.forEach((step: AuthStep) => {
    step.items.forEach(({ item }: AuthStepLabelledItem) => {
      if (item.type === AuthStepItemType.Url) {
        const value = params[item.name];
        const urlValues =
          value && Array.isArray(value)
            ? value
            : (new Array(item.parts.length).fill('') as Array<string>);

        item.parts.forEach((part: UrlPart, partIx: number) => {
          if (part.type === UrlPartType.Static) {
            urlValues[partIx] = part.value || '';
          }
        });

        const pathIndex = item.parts.findIndex(
          (part) => part.type === UrlPartType.Path
        );
        const domainParts =
          pathIndex === -1 ? urlValues : urlValues.slice(0, pathIndex);
        const pathParts = pathIndex === -1 ? [] : urlValues.slice(pathIndex);
        const url = `${domainParts
          .map((domainPart) => domainPart.trim())
          .join('.')
          .replace(/^(https?|ftp):\/\//, '')
          .replace(/\/$/, '')}${
          pathParts.length > 0
            ? `/${pathParts.map((pathPart) => pathPart.trim()).join('/')}`
            : ''
        }`;

        payload.inputParams[item.name] = url;
      } else if ('name' in item) {
        const value = params[item.name];
        const trimmedValue = value && !Array.isArray(value) ? value.trim() : '';
        payload.inputParams[item.name] = trimmedValue;
      }
    });
  });

  if (oAuthParams && oAuthState) {
    oAuthParams.forEach((value, key) => {
      payload.upstreamParams[key] = value;
    });

    payload.oAuthParams = {
      state: oAuthState,
      scopeSet: oAuthScopeSet,
      ...(mcpParams?.clientId ? { clientId: mcpParams.clientId } : {}),
      ...(mcpParams?.serverUrl ? { mcpServerUrl: mcpParams.serverUrl } : {}),
    };
  }

  payload.authParams = {
    ...payload.inputParams,
  };

  return payload;
}
